module.exports = __webpack_public_path__ + "img/Off Center Stone.0ea6c0be.png";